// Returns the dynamic entry span immediately after the collapsed cursor, when the
// cursor sits right before it without actually being inside it (e.g. in the parent
// element right before the span, or at the very end of a text node that precedes it).
export function getFollowingDynamicSpan(rng: Range): HTMLElement | null {
	const { startContainer, startOffset } = rng;

	const node =
		startContainer.nodeType === Node.TEXT_NODE
			? startOffset === (startContainer as Text).length
				? startContainer.nextSibling
				: null
			: (startContainer.childNodes[startOffset] ?? null);

	return node?.nodeType === Node.ELEMENT_NODE && (node as Element).hasAttribute('data-id')
		? (node as HTMLElement)
		: null;
}
